import { render, staticRenderFns } from "./api-header.vue?vue&type=template&id=35ca8a1f"
import script from "./api-header.vue?vue&type=script&lang=js"
export * from "./api-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports